module.exports = __webpack_public_path__ + "static/media/recommendation-systems-5.95f11aba.jpg";